// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  margin-top: 3rem;
  height: 50vh;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

.spinner {
  width: 56px;
  height: 56px;
  border-radius: 50%;
  border: 9px solid;
  border-color: #dedede;
  border-right-color: var(--primaryColor);
  animation: spinner-d3wgkg 1s infinite linear;
}

.ai-diamond {
  position: absolute;
  display: block;
  top: 8px;
  left: 8px;
  background-image: url('aidiamond.svg');
  background-size: cover;
  height: 25px;
  width: 25px;
  z-index: 999;
}

@keyframes spinner-d3wgkg {
  to {
    transform: rotate(1turn);
  }
}`, "",{"version":3,"sources":["webpack://./src/app/page-loader/page-loader.component.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;AACF;;AAEA;EACG,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,qBAAA;EACA,uCAAA;EACA,4CAAA;AACH;;AACA;EACI,kBAAA;EACA,cAAA;EACA,QAAA;EACA,SAAA;EACA,sCAAA;EACA,sBAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;AAEJ;;AAAA;EACG;IACG,wBAAA;EAGJ;AACF","sourcesContent":[":host{\n  margin-top:3rem;\n  height: 50vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n}\n \n.spinner {\n   width: 56px;\n   height: 56px;\n   border-radius: 50%;\n   border: 9px solid;\n   border-color: #dedede;\n   border-right-color: var(--primaryColor);\n   animation: spinner-d3wgkg 1s infinite linear;\n}\n.ai-diamond{\n    position: absolute;\n    display: block;\n    top:8px;\n    left:8px;\n    background-image: url('../../assets/images/aidiamond.svg');\n    background-size: cover;\n    height:25px;\n    width:25px;\n    z-index:999;\n  }\n@keyframes spinner-d3wgkg {\n   to {\n      transform: rotate(1turn);\n   }\n}\n "],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
